import { render, staticRenderFns } from "./DateTime.vue?vue&type=template&id=5d990082&scoped=true"
import script from "./DateTime.vue?vue&type=script&lang=js"
export * from "./DateTime.vue?vue&type=script&lang=js"
import style0 from "./DateTime.vue?vue&type=style&index=0&id=5d990082&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d990082",
  null
  
)

export default component.exports